<template>
    <BlockConfig title="Tabella misure"
    :valid="valid"
    @handleSave="handleSave"
    @restore="restore">
    <v-form v-model="valid">
        <div class="d-flex my-2">
            <v-text-field dense outlined
                label="nome prova*"
                :rules="[rules.mandatory]" 
                v-model="config_data.title"
            ></v-text-field>
            <v-text-field dense outlined
                class="ml-2" 
                :rules="[rules.mandatory]" 
                v-model="config_data.min_readings"
                label="misure minime*">
            </v-text-field>
        </div>
        <div class="d-flex my-2">
            <v-text-field dense outlined
                label="traduzione inglese"
                v-model="config_data.translation"
            ></v-text-field>
        </div>
        <div>
            <v-label>etichette tabella<span class="caption"> - (ordine fisso)</span></v-label>
            <div class="d-flex mt-2 flex-wrap">
                <v-text-field dense outlined label="Pressione nominale" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.nom"></v-text-field>
                <v-text-field dense outlined label="Lettura primario" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.primaryReading"></v-text-field>
                <v-text-field dense outlined label="Valore interpolato" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.conv"></v-text-field>
                <v-text-field dense outlined label="Lettura" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.reading"></v-text-field>
                <v-text-field dense outlined label="Errore" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.difference"></v-text-field>
                <v-text-field dense outlined label="Incertezza" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.uncertain"></v-text-field>
                <v-text-field dense outlined label="Errore formattato" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.toleranceError"></v-text-field>
                <v-text-field dense outlined label="Tolleranza" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.tolerance"></v-text-field>
                <v-text-field dense outlined label="Risultato" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.result"></v-text-field>
            </div>
        </div>
    </v-form>
    </BlockConfig>
</template>
<script>
import {ConfigMixin} from '../../../utils/configMixin_new'
import BlockConfig from '../../../components/utils/BlockConfig'

export default {
    components: {BlockConfig},
    mixins: [ConfigMixin],
    data(){
        return{
            // rules: f_rules,
            // valid: false,
            o_data:{
                title: this.data.block.label,
                translation: "",
                capacity: 0,
                min_readings: 3,
                headers: {
                    'count': 'n',
                    'nom': 'valore nominale',
                    'primaryReading': 'lettura primario',
                    'conv': 'valore interpolato',
                    'reading': 'lettura',
                    'uncertain': 'incertezza interpolata',
                    'difference': 'errore rilevato',
                    'toleranceError': 'errore formattato',
                    'tolerance': 'tolleranza',
                    'result': 'risultato'
                }
            },
        }
    }
}
</script>
